// AlertContext.js
import React, { createContext, useContext, useState } from "react";

type AlertContextType = {
  alertType: string;
  alertMessage: string;
  showAlert: boolean;
  path: string;
  setAlert: (type: string, message: string, path?: string) => void;
  closeAlert: () => void;
};

const AlertContext = createContext<AlertContextType>({
  alertType: "info",
  alertMessage: "",
  showAlert: false,
  path: "",
  setAlert: () => {},
  closeAlert: () => {},
});

export const useAlert = () => useContext(AlertContext);

export const AlertProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [alertType, setAlertType] = useState("info");
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [path, setPath] = useState("");

  const setAlert = (type: string, message: string, path?: string) => {
    setAlertType(type);
    setAlertMessage(message);
    setPath(path || "");
    setShowAlert(true);
  };

  const closeAlert = () => {
    setShowAlert(false);
  };

  return (
    <AlertContext.Provider value={{ alertType, alertMessage, showAlert, path, setAlert, closeAlert }}>
      {children}
    </AlertContext.Provider>
  );
};
